import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-fields" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = { class: "input-container description-container" }
const _hoisted_4 = {
  key: 0,
  class: "character-counter"
}
const _hoisted_5 = { class: "date-wrapper" }
const _hoisted_6 = { class: "documents-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_AddDocuments = _resolveComponent("AddDocuments")!

  return (_openBlock(), _createElementBlock("form", {
    class: "form-container",
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          id: "objet-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objetValue) = $event)),
          class: "object-input",
          name: "objet",
          required: "",
          type: "text",
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleObjetFocus(false))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleObjetFocus(true)))
        }, null, 544), [
          [_vModelText, _ctx.objetValue]
        ]),
        _createElementVNode("label", {
          class: _normalizeClass([_ctx.objetValue || _ctx.objetFocus ? 'active-label' : '', "label"]),
          for: "objet-input"
        }, _toDisplayString(_ctx.$t('app.ask.estimate.subject')), 3)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("textarea", {
          id: "descriptif",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.descriptifValue) = $event)),
          class: "description-input",
          cols: "30",
          maxlength: "4000",
          minlength: "50",
          name: "descriptif",
          required: "",
          rows: "7",
          onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleDescriptionFocus(false))),
          onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleDescriptionFocus(true)))
        }, null, 544), [
          [_vModelText, _ctx.descriptifValue]
        ]),
        _createElementVNode("label", {
          class: _normalizeClass([_ctx.descriptifValue || _ctx.descriptionFocus ? 'active-label' : '', "label"]),
          for: "descriptif"
        }, _toDisplayString(_ctx.$t('app.ask.estimate.description')), 3),
        _createVNode(_component_ReglePastille, { cle: "demandeDevis.descriptionMinimale" }),
        (_ctx.remainingDescriptionCharacterCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('app.ask.estimate.remainingCharacters')) + " " + _toDisplayString(_ctx.remainingDescriptionCharacterCount), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DatePicker, {
          dateMin: _ctx.today,
          dateValue: _ctx.dateValue,
          label: _ctx.$t('app.ask.estimate.date'),
          onSetDate: _ctx.setDate
        }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"]),
        _createVNode(_component_ReglePastille, { cle: "demandeDevis.dateSouhaitee" })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_AddDocuments, {
        documents: _ctx.files,
        onAdd: _ctx.addFile,
        onRemove: _ctx.removeFile
      }, null, 8, ["documents", "onAdd", "onRemove"]),
      _createVNode(_component_ReglePastille, { cle: "demandeDevis.piecesJointes" })
    ])
  ], 32))
}